export default __webpack_public_path__ + "static/Ogg-Medium-481bbdb76b964ce8601c7fa33999aff0.ttf";